import { renderPage } from "renderPage"
import { ClubGiftShowPage } from "./Page"

renderPage({ component: ClubGiftShowPage })
